import {Directive, forwardRef, HostListener} from '@angular/core';
import {DefaultValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Directive({
  selector: '[appDecimalsOnly]',
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DecimalsOnlyDirective),
      multi: true,
    },
  ],
})
export class DecimalsOnlyDirective extends DefaultValueAccessor {
  @HostListener('input', ['$event.target.value'])
  onInput(value: string): void {
    const updatedValue = value.replace(/[^0-9.]/g, '');
    this.onChange(updatedValue);
    this.writeValue(updatedValue);
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string): void {
    this.writeValue(value.replace(/[^0-9.]/g, ''));
  }
}
